import { Contacts } from "./IContacts";
import { Addresses } from "./IAdressess";
import { Documents } from "./IDocuments";
import { PersonalsData } from "./IPersonalData";
import { Users } from "./iUser";
import { BusinessUnits } from "./IBusinessUnits";
import { ProfessionalDatas } from "./iProfessionalData";
import { PIX } from "./iPersonPixAddressKey";

export namespace Persons {
  export interface IPerson {
    id: number;
    userId: number;
    user: Users.IUser;
    personalDataId: number;
    personalData: PersonalsData.IPersonalData;
    distance: string;
    distanceValue: number;
    addressId: number;
    address?: Addresses.IAddress;
    documents: Documents.IDocument[];
    contacts: Contacts.IContact[];
    professionalData: ProfessionalDatas.IProfessionalData;
    pixAddressKey: PIX.IPixAddressKey;
    administrativeUser: boolean;
    businessUnit: BusinessUnits.IBusinessUnit;
    businessUnitPersonType: number | undefined;
    averageGrade: number;
    evaluationsCount: number;
    marking: boolean;
    fastHiring: boolean;
    frozen: boolean;
    frozenDate: string;
    status: number;

    creationDate: string;
    creationUserId: number;
    updateDate: string;
    updateUserId: number;
    deletionDate: string;
    deletionUserId: number;
    count: number;
  }

  export class Person implements IPerson {
    id: number = 0;
    userId: number = 0;
    user: Users.IUser = new Users.User();
    personalDataId: number = 0;
    personalData: PersonalsData.IPersonalData = new PersonalsData.PersonalData();
    distance: string = "";
    distanceValue: number = 0;
    addressId: number = 0;
    address?: Addresses.IAddress = new Addresses.Address();
    documents: Documents.IDocument[] = new Array<Documents.IDocument>();
    contacts: Contacts.IContact[] = new Array<Contacts.IContact>();
    professionalData: ProfessionalDatas.IProfessionalData = new ProfessionalDatas.ProfessionalData();
    pixAddressKey: PIX.IPixAddressKey = new PIX.PixAddressKey();
    administrativeUser: boolean = false;
    businessUnit = new BusinessUnits.BusinessUnit();
    businessUnitPersonType: number | undefined = undefined;
    averageGrade: number = 0;
    evaluationsCount: number = 0;
    marking: boolean = false;
    fastHiring: boolean = false;
    frozen: boolean = false;
    frozenDate: string = "";
    status: number = 0;

    creationDate: string = "";
    creationUserId: number = -1;
    updateDate: string = "";
    updateUserId: number = -1;
    deletionDate: string = "";
    deletionUserId: number = -1;
    count: number = 0;
  }
}
